<template lang="pug">
li.cart-line-item(:class="line != 1 ? 'cart-line-item--separated' : null" :data-free-sample="freeSampleProduct")
  .cart-line-item__image-container
    img.cart-line-item__image(:src="item.image | image('250x')" :alt="item.product_title")
  .cart-line-item__details
    a.cart-line-item__product-title(v-if="!freeSampleProduct" :href="item.url" v-html="item.product_title")
    p.cart-line-item__product-title(v-else="!freeSampleProduct" v-text="item.product_title")
    p.cart-line-item__variant-name(v-if="item.variant_title && item.variant_title.toLowerCase() != 'default title'") {{ item.variant_title }}
    p.cart-line-item__product-price.cart-line-item__product-price--discounted(v-if="item.original_price > item.line_price") 
      span {{item.original_price | moneyWithoutDecimals}}
      span {{item.line_price | moneyWithoutDecimals}}
    p.cart-line-item__product-price(v-else-if="!freeSampleProduct") {{item.discounted_price | moneyWithoutDecimals}}
    .cart-line-item__actions
      .cart-line-item__price(v-if="!freeSampleProduct") {{item.line_price | moneyWithoutDecimals}}
      .cart-line-item__price(v-else) FREE
      .cart-line-item__quantity
        .quantity-input
          button.quantity-input__increment(v-if="!freeSampleProduct" @click="increment" aria-label="Increase Quantity" :disabled="item.line_price === 0")
            icon(name="plus" height="16" width="16")
          button.quantity-input__decrement(v-if="!freeSampleProduct" @click="decrement" aria-label="Decrease Quantity" :disabled="quantity === 1")
            icon(name="minus" height="16" width="16")
          input.quantity-input__text(:value="thisQuantity" type="text" readonly)
  button.button--icon.cart-line-item__remove(@click="removeItem")
    .u-sr-only Remove Item
    Icon(name="close" height="25" width="25")
</template>

<script>
  import Icon from 'scripts/components/basic/Icon.vue';

  export default {
    name: 'CartLineItem',
    components: { Icon },
    props: {
      item: Object,
      line: Number,
      freeSampleProduct: Boolean,
    },
    data() {
      return {
        quantity: this.item.quantity,
      };
    },
    computed: {
      thisQuantity() {
        return this.quantity == this.item.quantity ? this.quantity : this.item.quantity
      },
    },
    methods: {
      increment() {
        if (this.quantity < window.MaxProductQuantity) {
          this.quantity++
          this.updateItem()
        }
      },
      decrement() {
        this.quantity--
        this.updateItem()
      },
      updateItem() {
        if (this.quantity > 0) {
          this.$store.dispatch('cart/updateItem', { line: this.line, quantity: this.quantity })
        }
      },
      removeItem() {
        this.$store.dispatch('cart/removeItem', this.line);
        window.bvaDatalayerRemoveFromCartEvent(this.item);
      },
    },
    created() {
      this.$store.dispatch('cart/init');
    },
    mounted() {
      this.$store.dispatch('cart/init');
    }
  };
</script>

<style scoped lang="scss">
  .cart-line-item {
    display: flex;
    position: relative;
    padding: 20px 0;
    color: var(--color-charcoal);
    transition: all 0.3s ease-in-out;
  }
  .cart-line-item--separated {
    border-top: 1px solid var(--color-grey-400);
  }
  .cart-line-item__image-container {
    aspect-ratio: 1 / 1.1;
    flex: 0 0 130px;
    display: inline-flex;
    border: 1px solid var(--color-grey-400);
    background-color: var(--color-white);
  }
  .cart-line-item__image {
    object-fit: cover;
    display: block;
    height: 100%;
    width: 100%;
    object-position: bottom center;
  }

  .cart-line-item__variant-name,
  .cart-line-item__product-price {
    padding-right: 25px;
    font-family: var(--font-family-header-secondary);
  }

  .cart-line-item__product-title {
    font-size: rem(17);
    line-height: 110%;
    text-decoration: none;
    color: var(--color-charcoal);
    margin-bottom: rem(5);
    padding-right: rem(25);
    font-family: var(--font-family-header);
  }
  .cart-line-item__variant-name {
    font-size: rem(12px);
    text-transform: uppercase;
    color: var(--color-charcoal);
    margin-bottom: 0;
    letter-spacing: 1px;
  }
  .cart-line-item__price,
  .cart-line-item__product-price {
    font-size: rem(17);
    margin: 0;
    color: var(--color-charcoal);
    line-height: rem(27);
    font-family: var(--font-family-primary);
    font-weight: var(--font-weight-normal);
  }
  .cart-line-item__product-price--discounted {
    span:first-child {
      text-decoration: line-through;
      color: var(--color-grey-500);
      margin-right: 4px;
    }
     span:last-child {
      margin-left: 5px;
    }
  }
  .cart-line-item__details {
    flex-grow: 1;
    padding: 0 0 0 20px;
    display: flex;
    flex-direction: column;
  }
  .cart-line-item__actions {
    display: flex;
    align-items: center;
    flex-direction: row-reverse;
    justify-content: space-between;
    margin-top: auto;
    .loading {
      width: 20px;
      height: 20px;
    }
  }
  .cart-line-item__quantity {
    width: auto;
  }
  .cart-line-item__remove {
    position: absolute;
    top: 20px;
    right: 0;
    font-size: rem(9);
    text-transform: uppercase;
    color: var(--color-charcoal);
    background: transparent;
    border: 0;
    padding: 0;
    min-width: auto;
  }
  .u-sr-only {
    border: 0;
    clip: rect(0 0 0 0);
    height: auto;
    margin: 0;
    overflow: hidden;
    padding: 0;
    position: absolute;
    width: 1px;
    white-space: nowrap;
  }
  .button--icon.cart-line-item__remove {
    cursor: pointer;
  }

  // Quantity Input
  .quantity-input {
    display: flex;
    align-items: center;
    width: 86px !important;
    height: 44px;
    overflow: hidden;
    border: 1px solid var(--color-grey-400);
    position: relative;
    font-size: rem(16px);

    @include tablet-up() {
      width: 130px;
    }
  }
  button.quantity-input__increment,
  button.quantity-input__decrement {
    position: absolute;
    top: 0;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    cursor: pointer;
    background-color: transparent;
    
    .icon {
      color: var(--color-charcoal);
    }
    &:disabled {
      .icon {
        color: var(--color-grey-500) !important;
      }
    }
  }
  /deep/ button.quantity-input__increment {
    padding: 0 rem(12px) 0 0;
    right: 0;
  }
  /deep/ button.quantity-input__decrement {
    padding: 0 0 0 rem(12px);
    left: 0;
  }
  input[type='text'].quantity-input__text {
    border: 0 !important;
    outline: 0 !important;
    text-align: center;
  }
</style>
